<template>
  <div id="tag-insert-data">
    <basic-insert-data
      masterName="タグ"
      :inputTypes="inputTypes"
      :colorOptions="colorOptions"
      backTo="addon-port-master-tag-master"
      @insertData="insertData"
      ref="basicInsertData"
    >
    </basic-insert-data>
  </div>
</template>

<script>

import BasicInsertData from "../components/BasicInsertData";
import { snakeCase } from "snake-case";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    BasicInsertData
  },
  data() {
    return {
      inputTypes: [
        {
          label: "名称",
          inputType: "string",
          key: "name",
          regex: /.+/,
        },
        {
          label: "カラーコード",
          inputType: "color",
          key: "color",
        },
        {
          label: "備考",
          inputType: "textArea",
          key: "description",
        },
      ],
    }
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      colorOptions: state => state.colorOptions,
    }),
  },
  async created() {
    this.$vs.loading()
    await this.fetchColors(this.selectedPort.id)
    this.$vs.loading.close()
  },
  methods: {
    ...mapActions(["insertTag", "fetchColors"]),
    async insertData(value) {
      let enterpriseColorId = value[value.findIndex(element => element.key == "color")].value.id
      let name = value[value.findIndex(element => element.key == "name")].value
      let description = value[value.findIndex(element => element.key == "description")].value
      let payload = {
        portId: this.selectedPort.id,
        body: {
          color_id: enterpriseColorId,
          name: name,
          description: description,
          version: null
        }
      }
      try {
        this.$vs.loading()
        await this.insertTag(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            path: "port-master-tag-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.inputTypes.findIndex(column => column.key == targetKey)
            let label = this.inputTypes[index].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicInsertData.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicInsertData.openErrorPopup("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
